import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/engagement/csr-inquiries";

export const Route = createFileRoute("/admin/_engagement/csr-inquiries")({
  component: Page,
});
